import React, { useState } from 'react';
import Icon from 'components/AppIcon';
import { useAuth } from '@/contexts/AuthContext';

const SocialAuth = ({ isLoading }) => {
  const [loadingProvider, setLoadingProvider] = useState(null);

  const socialProviders = [
    {
      name: 'Google',
      icon: 'Chrome',
      color: 'bg-slate-50 dark:bg-neutral-900 border-2 border-slate-300 dark:border-neutral-700 text-neutral-900 dark:text-neutral-100 hover:bg-slate-100 dark:hover:bg-neutral-800 shadow-sm'
    }
  ];

  const { signInWithSocial } = useAuth();

  const handleSocialAuth = async (provider) => {
    if (isLoading) return;

    setLoadingProvider(provider.name);

    try {
      const providerId = provider.id || provider.name.toLowerCase();
      const { error } = await signInWithSocial(providerId);
      if (error) throw error;
    } catch (err) {
      console.error(`${provider.name} authentication error:`, err.message);
      setLoadingProvider(null);
    }
  };

  return (
    <div className="space-y-3">
      {socialProviders.map((provider) => (
        <button
          key={provider.name}
          onClick={() => handleSocialAuth(provider)}
          disabled={isLoading || loadingProvider}
          className={`w-full flex items-center justify-center space-x-3 py-3 px-4 border rounded-md font-medium transition-smooth min-h-touch ${provider.color} ${loadingProvider === provider.name ? 'opacity-75 cursor-not-allowed' : ''
            }`}
        >
          {loadingProvider === provider.name ? (
            <>
              <div className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin"></div>
              <span>Connecting to {provider.name}...</span>
            </>
          ) : (
            <>
              <Icon name={provider.icon} size={20} className={provider.name === 'Google' ? 'text-red-500' : ''} />
              <span>Continue with {provider.name}</span>
            </>
          )}
        </button>
      ))}
    </div>
  );
};

export default SocialAuth;